<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Pay Head List"
                btnTitle="Add New"
                :showAddNew="true"
                @onClickAddNewButton="onClickAddNewButton"
            />
        </div>
        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card p-2" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>SL</th>
                  <th class="text-center">Name</th>
                  <th class="text-center">Short Name</th>
                  <th class="text-center">Description</th>
                  <th class="text-center">Type</th>
                  <th class="text-center">Income Type</th>
                  <th class="text-center">Gross Salary Component?</th>
                  <th class="text-center">Calculation Type</th>
                  <th class="text-center">Pay Head</th>
                  <th class="text-center">Value</th>
                  <th class="text-center">Calculation Period</th>
                  <th class="text-center">Payroll Category</th>
                  <th class="text-center">Payroll Category Type</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tableItems.data" :key="i">
                  <td>{{ i + 1 + ((tableItems.current_page - 1) * parseInt(tableItems.per_page)) }}</td>
                  <td class="text-center">{{ item.name }}</td>
                  <td class="text-center">{{ item.short_name }}</td>
                  <td class="text-center">{{ item.description }}</td>
                  <td class="text-center">{{ item.type_name }}</td>
                  <td class="text-center">{{ item.income_type_name }}</td>
                  <td class="text-center">{{ item.gross_salary_component === 1 ? 'Yes' : 'No' }}</td>
                  <td class="text-center">{{ item.calculation_type_name }}</td>
                  <td class="text-center">{{ item.parent_name }}</td>
                  <td class="text-center">{{ item.value }}</td>
                  <td class="text-center">{{ item.calculation_period_name }}</td>
                  <td class="text-center">{{ item.payroll_category_name }}</td>
                  <td class="text-center">{{ item.payroll_category_type_name }}</td>
                  <td class="text-center">{{ item.status_name }}</td>
                  <td class="text-center">
                    <button class="btn btn-primary btn-sm"
                            @click="goToEdit(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="tableItems.data && tableItems.data.length < 0" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const params = ref({
    offset: 20,
});

const token = computed(() => localStorage.getItem('token'));

const {
  fetchPayHead
} = handleHrPayroll()

function onClickAddNewButton() {
  router.push({name: `pay-head-add`, params: route.params, query: route.query})
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getPayHead();
}

const goToEdit = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.payHeadId = item.id;

  router.push({
    name:  'pay-head-add',
    params: param,
    query: query
  })
}

const getPayHead = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchPayHead(query).then(res => {
        if (!res.status){
            store.commit("resetPagination")
            return
        }

        tableItems.value = res.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    query += '&offset=' + params.value.offset
    return query;
}

onMounted(() => {
    Promise.all([
      getPayHead(),
    ])
})
</script>
